<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <div class="mt-4 signature-maker-wrapper">
        <!-- @vue-ignore -->
        <SignatureMaker
          v-model="value"
          :with-submit="false"
          :with-color-select="false"
          :undo-button-text="undoText"
          :clear-button-text="clearText"
          :undo-button-class="controlButtonClass"
          :clear-button-class="controlButtonClass"
          :text-input-placeholder="placeholderText"
          :draw-type-button-text="drawText"
          :text-type-button-text="typeText"
          :upload-type-button-text="uploadText"
          :draw-type-button-class="typeButtonClass"
          :draw-type-button-active-class="typeButtonActiveClass"
          :text-type-button-class="typeButtonClass"
          :text-type-button-active-class="typeButtonActiveClass"
          :upload-type-button-class="typeButtonClass"
          :upload-type-button-active-class="typeButtonActiveClass"
        />
      </div>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { computed } from 'vue'
import { defineElement } from '@vueform/vueform'
import { useI18n } from 'vue-i18n'
import { SignatureMaker } from '@docuseal/signature-maker-vue'

export default defineElement({
  name: 'CustomSignatureElement',
  setup(_props: Object, context: any) {
    const { value } = context.element
    const { t } = useI18n()
    return {
      value,
      undoText: computed(() => t('common.buttons.undo')),
      clearText: computed(() => t('common.buttons.clear')),
      placeholderText: computed(() => t('common.buttons.typeSignatureHere')),
      drawText: computed(() => t('common.buttons.draw')),
      typeText: computed(() => t('common.buttons.type')),
      uploadText: computed(() => t('common.buttons.upload')),
      typeButtonClass: 'signature-type-btn signature-type-btn--inactive',
      typeButtonActiveClass: 'signature-type-btn signature-type-btn--active',
      controlButtonClass: 'signature-control-btn'
    }
  },
  components: { SignatureMaker }
})
</script>

<style scoped>
/* Finnecto style: type buttons are <label> elements, secondary #2A3141, icon left of text */
.signature-maker-wrapper :deep(label.signature-type-btn) {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  text-transform: none !important;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.signature-maker-wrapper :deep(label.signature-type-btn--inactive) {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: #41434d;
}

.signature-maker-wrapper :deep(label.signature-type-btn--inactive:hover) {
  background: #f5f5f5;
}

.signature-maker-wrapper :deep(label.signature-type-btn--active) {
  background: #2a3141;
  border: 1px solid #2a3141;
  color: white;
}

.signature-maker-wrapper :deep(label.signature-type-btn svg) {
  flex-shrink: 0;
}

/* Override docuseal ResizeObserver that hides text when width < 576px */
.signature-maker-wrapper :deep(label.signature-type-btn span) {
  display: inline-block !important;
}

/* Finnecto style for Undo/Clear buttons */
.signature-maker-wrapper :deep(button.signature-control-btn) {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  text-transform: none !important;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: #41434d;
  transition: background-color 0.2s;
}

.signature-maker-wrapper :deep(button.signature-control-btn:hover) {
  background: #f5f5f5;
}

.signature-maker-wrapper :deep(button.signature-control-btn svg) {
  flex-shrink: 0;
}

/* Text input: reduce size, gap to canvas, Finnecto font/color for placeholder */
.signature-maker-wrapper :deep(input[placeholder]) {
  margin-bottom: 8px;
  height: 40px !important;
  min-height: 40px !important;
  padding: 12px 16px !important;
  font-size: 14px;
  line-height: 1;
  box-sizing: border-box !important;
}

.signature-maker-wrapper :deep(input[placeholder]::placeholder) {
  font-family: "Encode Sans", sans-serif;
  font-size: 16px;
  line-height: 1;
  color: rgba(65, 67, 77, 0.6);
}
</style>
